import { atom } from 'recoil';
import { OrderDetails } from '../../types/order.types';

export const currentOpenOrders = atom<OrderDetails[]>({
  key: 'currentOpenOrders',
  default: [],
});
